import { ColumnVisibility, type ColumnsType } from "@/types/tableState.types";

export const buildVisibleColumnsPayload = (
  columns?: ColumnsType[],
  columnsTitleCreator?: (column: string) => string,
) => {
  if (!columns?.length) return undefined;
  return columns
    .filter((c) => c.visibility === ColumnVisibility.VISIBLE)
    .map((c) => ({
      field: c.fieldName,
      label: columnsTitleCreator
        ? columnsTitleCreator(c.fieldName)
        : c.fieldName,
    }));
};

export const buildAvailableColumnsPayload = (
  columns?: ColumnsType[],
  columnsTitleCreator?: (column: string) => string,
) => {
  if (!columns?.length) return undefined;
  return columns
    .filter(
      (c) =>
        c.visibility === ColumnVisibility.VISIBLE ||
        c.visibility === ColumnVisibility.HIDDEN,
    )
    .map((c) => ({
      field: c.fieldName,
      label: columnsTitleCreator
        ? columnsTitleCreator(c.fieldName)
        : c.fieldName,
    }));
};
